var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.015,
    height: 21.832,
    viewBox: "0 0 24.015 21.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72164",
    "data-name": "Path 72164",
    d: "M13.007,13.555l4.631,4.631L16.095,19.73l-2-1.995v6.1H11.916v-6.1l-2,2L8.376,18.186ZM13.007,2A7.642,7.642,0,0,1,20.6,8.761a6.005,6.005,0,0,1-1.041,11.771v-2.2a3.821,3.821,0,0,0-.547-7.6,3.76,3.76,0,0,0-.667.059A5.458,5.458,0,1,0,7.549,9.641a5.413,5.413,0,0,0,.122,1.15A3.821,3.821,0,0,0,6.261,18.3l.2.033v2.2A6,6,0,0,1,5.417,8.761,7.641,7.641,0,0,1,13.007,2Z",
    transform: "translate(-1 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/upload_img.0ae72c5c685e8315e68bbb02e1314adb.svg";
export { ForwardRef as ReactComponent };